/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Recovery_Codes_LeftInputs */

const en_recovery_codes_left = /** @type {(inputs: Recovery_Codes_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unused codes left`)
};

const de_recovery_codes_left = /** @type {(inputs: Recovery_Codes_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch ${i?.count} unbenutzte Codes`)
};

/**
* | output |
* | --- |
* | "{count} unused codes left" |
*
* @param {Recovery_Codes_LeftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_left = /** @type {((inputs: Recovery_Codes_LeftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_LeftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_left(inputs)
	return en_recovery_codes_left(inputs)
});